getPmScreenDataCreated